"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * eXtend Media Paywall Service API
 * Media Wall API Specification
 *
 * The version of the OpenAPI document: v1
 * Contact: t.ioannidis@extend.gr
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The DistributionPlanFilter model module.
 * @module model/DistributionPlanFilter
 * @version 1.1.3-alpha.1
 */
class DistributionPlanFilter {
  /**
   * Constructs a new <code>DistributionPlanFilter</code>.
   * @alias module:model/DistributionPlanFilter
   */
  constructor() {
    DistributionPlanFilter.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj) {}

  /**
   * Constructs a <code>DistributionPlanFilter</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/DistributionPlanFilter} obj Optional instance to populate.
   * @return {module:model/DistributionPlanFilter} The populated <code>DistributionPlanFilter</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new DistributionPlanFilter();
      if (data.hasOwnProperty('q')) {
        obj['q'] = _ApiClient.default.convertToType(data['q'], 'String');
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>DistributionPlanFilter</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>DistributionPlanFilter</code>.
   */
  static validateJSON(data) {
    // ensure the json data is a string
    if (data['q'] && !(typeof data['q'] === 'string' || data['q'] instanceof String)) {
      throw new Error("Expected the field `q` to be a primitive type in the JSON string but got " + data['q']);
    }
    return true;
  }
}

/**
 * @member {String} q
 */
DistributionPlanFilter.prototype['q'] = undefined;
var _default = exports.default = DistributionPlanFilter;